var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.liveblogEditorClasses,attrs:{"id":"editor"},on:{"click":_vm.onClick}},[(_vm.showFog)?_c('div',{staticClass:"embed__background",on:{"click":_vm.closeModal}}):_vm._e(),_c('EditorHeader'),_c('Editor')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }